import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import SlidingText from "../common/SlidingText";
export var QuickFilterCard = function QuickFilterCard(_ref) {
  var item = _ref.item,
    filters = _ref.filters,
    onFilterClick = _ref.onFilterClick;
  var isSelected = (filters === null || filters === void 0 ? void 0 : filters.id) === item.id ||
  // Single-select
  (filters === null || filters === void 0 ? void 0 : filters.selectedFilters) && Array.isArray(filters.selectedFilters) && filters.selectedFilters.some(function (f) {
    return f.id === item.id;
  }); // Multi-select
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col justify-between border h-20 sm:h-auto border-teal-500 text-left sm:text-right sm:whitespace-nowrap py-3 sm:!py-2 cursor-pointer dark:border-none dark:bg-gray-800 min-w-11 sm:min-w-[160px] max-w-[128px] sm:max-w-[200px] w-fit rounded-lg !px-4", {
      "!bg-teal-400 dark:!bg-teal-500 !text-gray-100": isSelected
    }),
    onClick: function onClick() {
      return onFilterClick(isSelected, item);
    },
    title: item.name
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("text-lg sm:text-2xl text-left sm:text-right font-medium text-gray-800 dark:text-gray-200", {
      "!text-gray-100": isSelected
    })
  }, !("count" in item) ? /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-gray-700 dark:border-white border-2 !border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-3",
    role: "status"
  }) : (item === null || item === void 0 ? void 0 : item.count) || 0), /*#__PURE__*/React.createElement("div", {
    className: classNames("text-md sm:text-[14px] leading-tight text-teal-500 dark:text-teal-300 overflow-hidden w-full max-w-full", {
      "!text-gray-100": isSelected
    })
  }, /*#__PURE__*/React.createElement(SlidingText, {
    text: item.name,
    className: classNames("text-teal-500 dark:text-teal-300", {
      "!text-gray-100": isSelected
    }),
    containerClassName: "w-full h-6 flex items-center overflow-hidden",
    speed: "fast",
    direction: "left"
  })));
};